import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { usePoll } from 'shared/hooks/usePoll'

import { getUserPromotionsPoll } from 'features/bonusSystem/actions'

export const PromotionsPolling: React.FC = () => {
  const dispatch = useDispatch()

  const getUserPromotionsFunc = useCallback(async () => {
    dispatch(getUserPromotionsPoll())
  }, [dispatch])

  usePoll(getUserPromotionsFunc, { delay: 20 })

  return null
}
